/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { request } from '@mairistem/tools';

const TYPES_VOIES_URL = '/api/transverse/typesvoies';
const PER_PAGE = 100;

// `request.get` renvoie un `Request` dont les `.then` ne s'enchaînent pas comme
// une promesse native (chaque callback reçoit la valeur du précédent sans
// attendre une promesse retournée) : on l'enveloppe pour pouvoir chaîner.
const getTypesVoiesPage = (page: number): Promise<any> =>
  new Promise((resolve, reject) => {
    request
      .get(`${TYPES_VOIES_URL}?page=${page}&perPage=${PER_PAGE}`)
      .then(resolve, reject);
  });

// Référentiel quasi statique : chargé une seule fois pour toute l'application.
let typesVoiesPromise: Promise<string[]> | null = null;

const fetchTypesVoies = (): Promise<string[]> => {
  if (!typesVoiesPromise) {
    typesVoiesPromise = getTypesVoiesPage(1)
      .then(({ data, meta }: any) =>
        Promise.all(
          _.range(2, (meta?.lastPage ?? 1) + 1).map(getTypesVoiesPage),
        ).then((pages: any[]) => [data, ..._.map(pages, 'data')]),
      )
      .then((pages) => _.compact(_.map(_.flatten(pages), 'libelle')))
      .catch(() => {
        // Nouvelle tentative au prochain montage.
        typesVoiesPromise = null;
        return [];
      });
  }

  return typesVoiesPromise;
};

/**
 * Libellés des types de voie du référentiel (« Rue », « Impasse »…).
 */
const useTypesVoies = (): string[] => {
  const [typesVoies, setTypesVoies] = React.useState<string[]>([]);

  React.useEffect(() => {
    let mounted = true;

    fetchTypesVoies().then((libelles) => {
      if (mounted) setTypesVoies(libelles);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return typesVoies;
};

export default useTypesVoies;
